/* RESPONSIBLE TEAM: team-standalone */
import { inject as service } from '@ember/service';
import IntercomRoute from 'embercom/routes/base/intercom-route';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';
import type GreatGuidanceService from 'embercom/services/great-guidance-service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type Session from 'embercom/services/session';
import type Controller from '@ember/controller';
import type Store from '@ember-data/store';

export default class StandaloneRoute extends IntercomRoute {
  @service declare appService: { app: { canUseStandalone: boolean; id: string } };
  @service declare session: Session;
  @service declare router: RouterService;
  @service declare store: Store;
  @service declare greatGuidanceService: GreatGuidanceService;
  @service declare finStandaloneService: FinStandaloneService;

  get app() {
    return this.appService.app;
  }
  async beforeModel(transition: Transition) {
    await this.finStandaloneService.initialize();
    this.session.switchWorkspace(this.app.id);
    this.session.workspace.fetchRequiredAttributes();

    if (transition.to.name === 'apps.app.standalone.index') {
      this.router.transitionTo('apps.app.standalone.reports');
    } else if (transition.to.name.startsWith('apps.app.standalone.setup')) {
      this.router.transitionTo('apps.app.standalone.deploy.overview');
    }

    let appsController = this.controllerFor('apps/app') as Controller & { showPrimaryNav: boolean };
    appsController.set('showPrimaryNav', false);
  }

  redirect(): any {
    if (!this.app.canUseStandalone) {
      return this.router.transitionTo('apps.app', this.app.id);
    }
  }
}
